import React from 'react'
import { Button } from '@heroui/react'

const ContenedorEnlace = ({
  children,
  mostrarBotones = false,
  estiloMiniatura = false,
  puedeSubir = false,
  puedeBajar = false,
  onMoverArriba,
  onMoverAbajo,
  onEditar,
  onEliminar,
  enlace
}) => {
  // No mostrar botones para cuentas bancarias (tienen su propio sistema)
  const esCuentaBancaria = enlace?.esCuentaBancaria || enlace?.tipo === 'cuenta_bancaria'
  
  if (!mostrarBotones || estiloMiniatura || esCuentaBancaria) {
    return (
      <div className="relative">
        {children}
      </div>
    )
  }

  return (
    <div className="relative group flex">
      {/* Botones de reorganización - Lado izquierdo vertical */}
      <div className="flex flex-col gap-1 mr-3 pt-2">
        {puedeSubir && (
          <Button
            isIconOnly
            size="sm"
            color="secondary"
            variant="solid"
            onPress={onMoverArriba}
            title="Mover hacia arriba"
            className="shadow-md min-w-8 h-8"
          >
            <i className="fas fa-arrow-up text-xs"></i>
          </Button>
        )}
        {puedeBajar && (
          <Button
            isIconOnly
            size="sm"
            color="secondary"
            variant="solid"
            onPress={onMoverAbajo}
            title="Mover hacia abajo"
            className="shadow-md min-w-8 h-8"
          >
            <i className="fas fa-arrow-down text-xs"></i>
          </Button>
        )}
      </div>
      
      {/* Contenedor del enlace */}
      <div className="flex-1 relative">
        {/* Botones de edición - Lado derecho superior */}
        <div className="absolute -top-2 -right-2 z-10 flex gap-1">
          <Button
            isIconOnly
            size="sm"
            color="primary"
            variant="solid"
            onPress={onEditar}
            className="shadow-md min-w-8 h-8"
          >
            <i className="fas fa-edit text-xs"></i>
          </Button>
          <Button
            isIconOnly
            size="sm"
            color="danger"
            variant="solid"
            onPress={onEliminar}
            className="shadow-md min-w-8 h-8"
          >
            <i className="fas fa-trash text-xs"></i>
          </Button>
        </div>
        
        {/* Contenido del enlace */}
        <div className="relative">
          {children}
        </div>
      </div>
    </div>
  )
}

export default ContenedorEnlace 